<template>
  <div class="questionnaire-list">
    <div
      v-for="item in questionnaires" :key="item.id"
      class="questionnaire-list-item"
      @click="$emit('select-questionnaire', item.id)">

      {{item.title}}
    </div>

    <div v-if="questionnaires.length === 0" class="questionnaire-empty">
      У Вас нет незаполненных анкет.
    </div>
  </div>
</template>

<script>
  export default {
    name: 'QuestionnaireList',

    props: ['questionnaires'],

    data() {
      return {};
    },

    computed: {
    },

    methods: {
    },
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .questionnaire-list {
    border-top: 1px solid $light-gray;

    .questionnaire-list-item {
      margin: 0 0 2px;
      padding: 20px 40px;
      border-bottom: 1px solid $light-gray;
      font-weight: bold;
      color: $primary;
      cursor: pointer;
    }
  }

  .questionnaire-empty {
    padding-top: 10px;

    text-align: center;
  }
</style>
